import clienteAxios from "../config/axios";

export async function getAllDocumentos() {
    return clienteAxios.get(`/documento`);
}

export async function addDocumento(doc){
    return clienteAxios.post('/documento',{doc});
}

export async function updateDocumento(doc){
    return clienteAxios.put('/documento',{updates:doc});
}

export async function deleteDocumento(idDoc){
    return clienteAxios.delete(`/documento/${idDoc}`);
}
